import { Component } from 'react';
import PropTypes from 'prop-types';
import { Message } from '@bwoty-web/ui-kit';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { tableLayout, children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        <Message header={tableLayout.errorHeading} messageType="error">
          {tableLayout.errorDescription}
        </Message>
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  tableLayout: PropTypes.shape({
    errorHeading: PropTypes.string,
    errorDescription: PropTypes.string,
  }),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
};

ErrorBoundary.defaultProps = {
  tableLayout: {
    errorHeading: 'tableLayout.errorHeading',
    errorDescription: 'tableLayout.errorDescription',
  },
  children: null,
};

export default ErrorBoundary;
